import API from './common';
import config from '../config';
const { apiUrl, emailUrl } = config;
/**
 * @param  {object} values 
 */
//calculate postcode
export const calculate = (values) => {
    //setting base url for calculation as it is diff for caclulation and forwarding email
    API.defaults.baseURL = apiUrl;
    return API.post(`/calculate`, values);
};

export const sendEmail = (values) => {
    //setting base url for email forward
    API.defaults.baseURL = emailUrl;
    return API.post(`/sendmail`, values);
};

